import { useState, useEffect } from "react";
import Axios from "axios";
import config from "../config";

const useFetchSettlement = (url) => {
  const [isLoading, setIsLoading] = useState(false);
  const [settlements, setSettlements] = useState(null);
  const [error, setError] = useState(null);

  const doFetch = async () => {
    if (navigator.onLine) {
      setIsLoading(true);

      try {
        var token = localStorage.getItem("token");

        var response = await Axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Abp.Tenantid": config.TENANT_ID
          },
        });

        setSettlements(response.data.result ?? []);
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setError(
        "No estas conectado a la red, intentalo de nuevo"
      );
    }
  };

  useEffect(() => {
    doFetch();
  }, [url]);

  return {
    isLoading,
    settlements,
    error,
  };
};

export default useFetchSettlement;
